import React from 'react';
import Grid from './grid.component';
import autoBind from 'react-autobind';
import _ from 'lodash';
import { process } from '@progress/kendo-data-query';
import { ExportTypes } from './parts/grid.factory';
import { mapFilterStatic } from '@common/helpers/filterStatic.helper';

const GridWithRef = React.forwardRef((props, ref) => <Grid ref={ref} {...props} />);
const fileManagerRoute = window.api_routes.smarAPD_FileManager_Domain;

class DataGrid extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      ...props,
      toolbar: { ...props.toolbar, staticGrid: true },
      selectedItens: []
    };
    autoBind(this);

    this.refGrid = React.createRef();
  }

  async onPrint(gridFilter, type) {
    let header;
    switch (type) {
      case ExportTypes.XLS:
        header = 'application/vnd.ms-excel';
        break;
      case ExportTypes.PDFLandscape:
        header = 'application/pdf;orientation=landscape';
        break;
      case ExportTypes.PDFPortrait:
        header = 'application/pdf;orientation=portrait';
        break;
      case ExportTypes.TXT:
        header = 'application/octet-stream';
        break;
    }

    const { sedeService, service } = this.props.options;
    const sede = sedeService ? await sedeService() : undefined;
    const filter = {
      ...this.mapFilterExport(gridFilter),
      pageNumber: 1,
      pageSize: 65536, //MAX_XLS_PAGE_SIZE
      Sede: sede,
    };
    let result = await service(filter, { headers: { Accept: header, 'Access-Control-Allow-Origin': '*' } });
    var url = new URL(result.headers['content-location']);
    location.href =`${fileManagerRoute}/FileManager/${url.search}`
  }

  mapOrderBy(item) {
    return { field: item.dataName, dir: item.order == 'A' ? 'asc' : 'desc' };
  }

  mapFilterExport(dataFilter) {
    return {
      dynamicGrid: this.state.dynamicGrid,
      filterItens: dataFilter.columns,
      filterOrder: dataFilter.order,
      pageNumber: dataFilter.pageNumber,
      pageSize: dataFilter.pageSize,
      parameters: dataFilter.parameters,
      recurso: dataFilter.recurso
    };
  }

  async onFetchData(gridFilter) {
    const { itens, hasPagination } = this.props;
    const { pageSize, pageNumber, order, columns } = gridFilter;

    var list = [];
    itens.forEach((item) => {
      var obj = {};
      columns.forEach((column) => {
        if (column.type === 'date') {
          if (item[column.dataName]) {
            obj[column.dataName] = new Date(item[column.dataName]);
          }
        } else obj[column.dataName] = item[column.dataName];
      });
      list.push({ ...item, ...obj });
    });

    var result = null;
    if (hasPagination != false) {
      result = process(list, {
        skip: (pageNumber - 1) * pageSize,
        take: pageSize,
        sort: order.map(this.mapOrderBy),
        filter: mapFilterStatic(columns),
      });
    } else {
      result = process(list, {
        sort: order.map(this.mapOrderBy),
      });
    }

    if(this.state.dynamicGrid)
      this.setState({dynamicGrid: JSON.stringify(result.data)});

    return { dataList: result.data, pageCount: result.total };
  }

  onCheckItem(item){
    this.props.itens.forEach((x, i)=> {
      var setCheck = true;
          
      for(var key in item){
      if(key != 'isChecked' && item[key] != x[key])
        setCheck = false;
      }

      if(setCheck){
        if (x.merge) this.props.itens[i] = x.merge({ isChecked: item.isChecked });
        else x.isChecked = item.isChecked;
      }
    });

    this.setState({selectedItens: this.props.itens?.filter((x)=> x.isChecked)});
  }

  onCheckAll(value){
    this.props.itens.forEach((x, i) => {
      if (x.merge) this.props.itens[i] = x.merge({ isChecked: value });
      else x.isChecked = value;
    });

    this.setState({selectedItens: this.props.itens?.filter((x)=> x.isChecked)});
  }

  render() {
    const { keepSelectedItensOnPages, onCheckItem, onCheckAll, disableNew } = this.props;

    this.refGrid = this.props.innerRef || this.refGrid;
    return <GridWithRef
      ref={this.refGrid}
      {...this.state}
      onFetchData={this.onFetchData}
      onPrint={this.state.dynamicGrid ? this.onPrint : null}
      onCheckItem={keepSelectedItensOnPages ? this.onCheckItem : onCheckItem}
      onCheckAll={keepSelectedItensOnPages ? this.onCheckAll : onCheckAll}
      keepSelectedItensOnPages={keepSelectedItensOnPages}
      disableNew={disableNew}
      />;
  }
}

export default React.forwardRef((props, ref) => <DataGrid innerRef={ref} {...props} />);
